import getBuildSlug from './get-build-slug';
import getDesignAutomation from './get-design-automation';
import getMetaTranslations from './get-meta-translations';
import getVariables from './get-variables';
import getWebsiteVariableByElement from './get-website-variable-by-element';

export default {
  getDesignAutomation,
  getBuildSlug,
  getMetaTranslations,
  getVariables,
  getWebsiteVariableByElement,
};
